import { RestaurantData } from '@deskbay/shared/types';
import { CONFIGURATION_RULES, ConfigAlert } from '@deskbay/shared/services/configurationAgent/rules';

export const configurationAgent = {
  /**
   * Analizza la configurazione e restituisce gli alert attivi
   */
  analyzeConfiguration(data: RestaurantData): ConfigAlert[] {
    return CONFIGURATION_RULES.filter(rule => rule.condition(data));
  },

  /**
   * Ottiene solo gli alert urgenti
   */
  getUrgentAlerts(data: RestaurantData): ConfigAlert[] {
    return this.analyzeConfiguration(data).filter(alert => alert.priority === 'urgent');
  },

  /**
   * Ottiene solo gli alert secondari
   */
  getSecondaryAlerts(data: RestaurantData): ConfigAlert[] {
    return this.analyzeConfiguration(data).filter(alert => alert.priority === 'secondary');
  },

  /**
   * Ottiene solo gli alert di sistema (placeholder — populated from DB)
   */
  getSystemAlerts(data: RestaurantData): ConfigAlert[] {
    return this.analyzeConfiguration(data).filter(alert => alert.priority === 'system');
  },

  /**
   * Verifica se ci sono alert urgenti non dismissibili
   */
  hasBlockingAlerts(data: RestaurantData): boolean {
    return this.getUrgentAlerts(data).some(alert => !alert.dismissible);
  },

  /**
   * Ottiene alert per categoria
   */
  getAlertsByCategory(data: RestaurantData, category: string): ConfigAlert[] {
    return this.analyzeConfiguration(data).filter(alert => alert.category === category);
  },

  /**
   * Conta gli alert per priorità
   */
  getAlertCounts(data: RestaurantData): { urgent: number; secondary: number; system: number } {
    const alerts = this.analyzeConfiguration(data);
    return {
      urgent: alerts.filter(a => a.priority === 'urgent').length,
      secondary: alerts.filter(a => a.priority === 'secondary').length,
      system: 0 // System notifications are loaded from DB separately
    };
  },

  /**
   * Verifica se un alert specifico è attivo
   */
  isAlertActive(data: RestaurantData, alertId: string): boolean {
    const alert = CONFIGURATION_RULES.find(a => a.id === alertId);
    return alert ? alert.condition(data) : false;
  }
};
